export default "__VITE_ASSET__CwaFVULL__"